import React, { ReactNode } from "react";
import styled from "styled-components";
import { getParagraph16RegularTypography } from "../../Typography/Paragraph16";
import { Paragraph12RegularSecondary } from "../../Typography/Paragraph12";
import { useTranslation } from "react-i18next";
import Icon from "../Icon/Icon";

const Root = styled.div`
  display: flex;
  align-items: center;
  background-color: ${(props) => props.theme.backgroundColor};
  border-radius: ${(props) => props.theme.borderRadius.md};
  padding: 24px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

const TextContainer = styled.div`
  flex: 1;
  padding: 0 28px;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 28px 0;
  }
`;

const Title = styled.p`
  ${getParagraph16RegularTypography};
  color: ${(props) => props.theme.primaryColor};

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    text-align: center;
  }
`;

const Description = styled(Paragraph12RegularSecondary)`
  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    text-align: center;
  }
`;

interface Props {
  titleKey?: string;
  descriptionKey?: string;
  actionButton?: ReactNode;
}

const EmptyState = ({
  titleKey = "empty-state-title",
  descriptionKey,
  actionButton = null,
}: Props) => {
  const { t } = useTranslation();
  const title = t(titleKey);
  const description = descriptionKey && t(descriptionKey);

  return (
    <Root>
      <Icon name="emptyState" size="30px" />
      <TextContainer>
        <Title>{title}</Title>
        {description && <Description>{description}</Description>}
      </TextContainer>
      {actionButton}
    </Root>
  );
};

export default EmptyState;
